// export const SERVER_IP = "http://196.188.249.109:5000"
export const SERVER_IP = "https://www.undp-damage-reporting.com/backend";
// export const SERVER_IP = "http://localhost:8000/"
